import { Box, Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import { getConfiguration } from "../../clients/configuration"
import { AccountsApi, ResponseError } from "../../clients"
import { useState } from "react"
import { setCurrentUser } from "../../redux/features/currentUser/currentUserSlice"
import { AppAlert } from "../AppAlerts/AppAlerts"
import { addAlertWithTimeout } from "../../redux/features/alerts/alertsHelpers"

export const MyAccountPrivacy = () => {

    const dispatch = useAppDispatch()
    const user = useAppSelector(state => state.currentUser.account)
    const [shareEmail, setShareEmail] = useState<boolean>(!user.hideEmailFromMembers)
    const [sharePhoneNumber, setSharePhoneNumber] = useState<boolean>(!user.hidePhoneFromMembers)

    const handleShareEmailChange = async (_, checked: boolean) => {
        setShareEmail(checked)
        const config = await getConfiguration()
        const accountsApi = new AccountsApi(config)
        await accountsApi.updateAccount({
            accountID: user.id,
            updateAccountRequest: {
                hideEmailFromMembers: !checked,
            }
        }).then(() => {
            dispatch(setCurrentUser({
                ...user,
                hideEmailFromMembers: !checked
            }))
            const appAlert = new AppAlert('success', 'Your email sharing preferences have been updated')
            addAlertWithTimeout(dispatch, appAlert)
        }).catch(async (err) => {
            setShareEmail(!checked)
            const responseErr = err as ResponseError
            if (responseErr.response.status === 409) {
                const text = await responseErr.response.text().catch(() => '')
                const appAlert = new AppAlert('error', text)
                addAlertWithTimeout(dispatch, appAlert, 3000)
            } else {
                const appAlert = new AppAlert('error', 'There was an error updating your email sharing preferences')
                addAlertWithTimeout(dispatch, appAlert)
            }
        })
    }

    const handleSharePhoneNumberChange = async (_, checked: boolean) => {
        setSharePhoneNumber(checked)
        const config = await getConfiguration()
        const accountsApi = new AccountsApi(config)
        await accountsApi.updateAccount({
            accountID: user.id,
            updateAccountRequest: {
                hidePhoneFromMembers: !checked,
            }
        }).then(() => {
            dispatch(setCurrentUser({
                ...user,
                hidePhoneFromMembers: !checked
            }))
            const appAlert = new AppAlert('success', 'Your phone number sharing preferences have been updated')
            addAlertWithTimeout(dispatch, appAlert)
        }).catch(async (err) => {
            setShareEmail(!checked)
            const responseErr = err as ResponseError
            if (responseErr.response.status === 409) {
                const text = await responseErr.response.text().catch(() => '')
                const appAlert = new AppAlert('error', text)
                addAlertWithTimeout(dispatch, appAlert, 3000)
            } else {
                const appAlert = new AppAlert('error', 'There was an error updating your phone number sharing preferences')
                addAlertWithTimeout(dispatch, appAlert)
            }
        })
    }

    return (
        <Box>
            <FormGroup>
                <FormControlLabel control={<Checkbox checked={shareEmail} onChange={handleShareEmailChange} />} label='Share Email' />
            </FormGroup>
            <Typography variant='caption' sx={{ ml: { xs: 0, sm: 3 } }}>
                Share your email with other members
            </Typography>
            <FormGroup sx={{ mt: 2 }}>
                <FormControlLabel control={<Checkbox checked={sharePhoneNumber} onChange={handleSharePhoneNumberChange} />} label='Share Phone Number' />
            </FormGroup>
            <Typography variant='caption' sx={{ ml: { xs: 0, sm: 3 } }}>
                Share your phone number with other members
            </Typography>
        </Box>
    )
}